module.exports = __webpack_public_path__ + "static/media/Checked.2e2a98a8.svg";